import React from 'react'
import {connect} from 'react-redux'
function chunkArray(myArray, chunk_size){
    var results = [];
    
    while (myArray.length) {
        results.push(myArray.splice(0, chunk_size));
    }
    
    return results;
}
class Gallery extends React.Component{
    constructor(props){
        super(props);
        this.state = {

        }
    }
    render(){
        
        if(!this.props.Content){ 
            return(
                <div className="">spin?</div>
            )
        }else{
            const {content, isLoading} = this.props.Content
           if(isLoading){
            return(
                <div className="">spin?</div>
            )
           }else{
            let {images} = content.Gallery
            images = chunkArray(images,images.length/4)
            console.log(images)
            return (
                <div className="Gallery">
                    <div class="row">
                    {images.map((group,key) => (
                        <div class="column">
                            {
                                group.map((image,key) => (
                                    <img src={image} alt=""/>
                                ))
                            }
                        </div>
                    ))}
                    </div>
                </div>
            )
           }
        }
    }
}
const mapStateToProps = (store) => ({
    Content: store.content
  })
  export default connect(mapStateToProps)(Gallery);